import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import {
  AgxRow,
  AgxColumn,
  AgxBodyText,
  AgxCaption,
  Images,
} from '@urbanx/agx-ui-components';
import { ComparablePropertyModel } from 'store/cmaPropertySearch/types';
import { formatCurrency } from 'utils/formatNumber';
import './CMAPropertySelectedCard.scss';

dayjs.extend(relativeTime);

interface CMAPropertySelectedCardProps {
  property: ComparablePropertyModel;
  onCloseSelectedCard: (propertyId: ComparablePropertyModel) => void;
}

export const CMAPropertySelectedCard = ({
  property,
  onCloseSelectedCard,
}: CMAPropertySelectedCardProps) => {
  const {
    propertyId,
    address,
    bedrooms,
    bathrooms,
    carSpaces,
    landArea,
    price,
    settlementDate,
  } = property;

  const timeAgo =
    settlementDate !== null ? dayjs(settlementDate).fromNow(true) : '';

  return (
    <AgxColumn
      extraClasses="cmaPropertySelectedCard"
      data-testid={propertyId}
      smallGap
    >
      <AgxRow spaceBetween>
        <AgxBodyText small ellipsisOverflow extraClasses="address">
          {address}
        </AgxBodyText>
        <Images.CloseOutline onClick={() => onCloseSelectedCard(property)} />
      </AgxRow>
      <AgxRow mediumGap>
        <AgxRow smallGap centered>
          <Images.Bed />
          <AgxCaption small>{bedrooms}</AgxCaption>
        </AgxRow>
        <AgxRow smallGap centered>
          <Images.Bath />
          <AgxCaption small>{bathrooms}</AgxCaption>
        </AgxRow>
        <AgxRow smallGap centered>
          <Images.Car />
          <AgxCaption small>{carSpaces}</AgxCaption>
        </AgxRow>
        <AgxRow smallGap centered>
          <Images.Area />
          <AgxCaption small>{landArea}m²</AgxCaption>
        </AgxRow>
      </AgxRow>
      <AgxRow largeGap spaceBetween>
        <AgxBodyText small>{formatCurrency(price, 0)}</AgxBodyText>
        <AgxBodyText small>{timeAgo}</AgxBodyText>
      </AgxRow>
    </AgxColumn>
  );
};
